import { useState, useEffect, useMemo } from 'react'
import { useQuery } from 'react-query'
import { isUndefined, isNull, isNaN } from 'lodash-es'
import { format, formatISO, startOfToday, addDays } from 'date-fns'

// Libs
import { fetchRecentLiveStreamingProductList } from '@/api/fetchRecentLiveStreamingProductList'
import { groupProductsByHour, getTargetTime } from '@/methods/handleLiveDealData'

// Constants
import { QUERY_KEY } from '@/constants/queryKey'

const DAYS_OF_THREE_MONTHS = 90

export const useRecentLiveStreamingProductList = (params: any) => {
  const { categoryId, initialData, enabledUndefinedCategoryId, startTime, endTime } = params

  const [selectedStartTime, setSelectedStartTime] = useState('')

  const { data, isFetched, isSuccess } = useQuery(
    [QUERY_KEY.FETCH_RECENT_LIVE_STREAMING_PRODUCT_LIST, { categoryId, startTime, endTime }],
    () =>
      fetchRecentLiveStreamingProductList({
        categoryId: Number(categoryId),
        startTime: startTime || formatISO(new Date(format(startOfToday(), 'yyyy/MM/dd 00:00:00'))),
        endTime: endTime || formatISO(new Date(format(addDays(startOfToday(), DAYS_OF_THREE_MONTHS), 'yyyy/MM/dd 00:00:00'))),
        pageNo: params.pageNo || 1,
        pageSize: params.pageSize || 20,
        group: params.group || false,
      }),
    {
      enabled: enabledUndefinedCategoryId || (!isUndefined(categoryId) && !isNull(categoryId) && !isNaN(categoryId)),
      initialData: initialData,
    },
  )

  const liveDealsData = data?.productsInfo

  const { timeList, productData } = useMemo(() => groupProductsByHour(liveDealsData), [liveDealsData])

  const { targetTime, isFuture, roomInfo } = getTargetTime(productData, selectedStartTime)

  useEffect(() => {
    if (timeList.today.length > 0) {
      setSelectedStartTime(timeList.today[0].value)
    } else if (timeList.tomorrow.length > 0) {
      setSelectedStartTime(timeList.tomorrow[0].value)
    }
  }, [timeList])

  return {
    recentLiveStreamingProductData: data || {},
    isRecentLiveStreamingProductListDataFetched: isFetched,
    isRecentLiveStreamingProductListDataSuccess: isSuccess,
    timeList,
    groupProductData: productData,
    selectedStartTime,
    setSelectedStartTime,
    targetTime,
    isFuture,
    roomInfo,
  }
}
